import { defineNuxtPlugin } from '#app/nuxt'
import { LazyProseADVue, LazyProseA, LazyProseAccordionDVue, LazyProseAccordion, LazyProseAccordionItemDVue, LazyProseAccordionItem, LazyProseBadgeDVue, LazyProseBadge, LazyProseBlockquoteDVue, LazyProseBlockquote, LazyProseCalloutDVue, LazyProseCallout, LazyProseCardDVue, LazyProseCard, LazyProseCardGroupDVue, LazyProseCardGroup, LazyProseCodeDVue, LazyProseCode, LazyProseCodeCollapseDVue, LazyProseCodeCollapse, LazyProseCodeGroupDVue, LazyProseCodeGroup, LazyProseCodeIconDVue, LazyProseCodeIcon, LazyProseCodePreviewDVue, LazyProseCodePreview, LazyProseCodeTreeDVue, LazyProseCodeTree, LazyProseCollapsibleDVue, LazyProseCollapsible, LazyProseEmDVue, LazyProseEm, LazyProseFieldDVue, LazyProseField, LazyProseFieldGroupDVue, LazyProseFieldGroup, LazyProseH1DVue, LazyProseH1, LazyProseH2DVue, LazyProseH2, LazyProseH3DVue, LazyProseH3, LazyProseH4DVue, LazyProseH4, LazyProseHrDVue, LazyProseHr, LazyProseIconDVue, LazyProseIcon, LazyProseImgDVue, LazyProseImg, LazyProseKbdDVue, LazyProseKbd, LazyProseLiDVue, LazyProseLi, LazyProseOlDVue, LazyProseOl, LazyProsePDVue, LazyProseP, LazyProsePreDVue, LazyProsePre, LazyProseScriptDVue, LazyProseScript, LazyProseStepsDVue, LazyProseSteps, LazyProseStrongDVue, LazyProseStrong, LazyProseTableDVue, LazyProseTable, LazyProseTabsDVue, LazyProseTabs, LazyProseTabsItemDVue, LazyProseTabsItem, LazyProseTbodyDVue, LazyProseTbody, LazyProseTdDVue, LazyProseTd, LazyProseThDVue, LazyProseTh, LazyProseTheadDVue, LazyProseThead, LazyProseTrDVue, LazyProseTr, LazyProseUlDVue, LazyProseUl, LazyProseCautionDVue, LazyProseCaution, LazyProseNoteDVue, LazyProseNote, LazyProseTipDVue, LazyProseTip, LazyProseWarningDVue, LazyProseWarning, LazyProseH5, LazyProseH6, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ProseADVue", LazyProseADVue],
["ProseA", LazyProseA],
["ProseAccordionDVue", LazyProseAccordionDVue],
["ProseAccordion", LazyProseAccordion],
["ProseAccordionItemDVue", LazyProseAccordionItemDVue],
["ProseAccordionItem", LazyProseAccordionItem],
["ProseBadgeDVue", LazyProseBadgeDVue],
["ProseBadge", LazyProseBadge],
["ProseBlockquoteDVue", LazyProseBlockquoteDVue],
["ProseBlockquote", LazyProseBlockquote],
["ProseCalloutDVue", LazyProseCalloutDVue],
["ProseCallout", LazyProseCallout],
["ProseCardDVue", LazyProseCardDVue],
["ProseCard", LazyProseCard],
["ProseCardGroupDVue", LazyProseCardGroupDVue],
["ProseCardGroup", LazyProseCardGroup],
["ProseCodeDVue", LazyProseCodeDVue],
["ProseCode", LazyProseCode],
["ProseCodeCollapseDVue", LazyProseCodeCollapseDVue],
["ProseCodeCollapse", LazyProseCodeCollapse],
["ProseCodeGroupDVue", LazyProseCodeGroupDVue],
["ProseCodeGroup", LazyProseCodeGroup],
["ProseCodeIconDVue", LazyProseCodeIconDVue],
["ProseCodeIcon", LazyProseCodeIcon],
["ProseCodePreviewDVue", LazyProseCodePreviewDVue],
["ProseCodePreview", LazyProseCodePreview],
["ProseCodeTreeDVue", LazyProseCodeTreeDVue],
["ProseCodeTree", LazyProseCodeTree],
["ProseCollapsibleDVue", LazyProseCollapsibleDVue],
["ProseCollapsible", LazyProseCollapsible],
["ProseEmDVue", LazyProseEmDVue],
["ProseEm", LazyProseEm],
["ProseFieldDVue", LazyProseFieldDVue],
["ProseField", LazyProseField],
["ProseFieldGroupDVue", LazyProseFieldGroupDVue],
["ProseFieldGroup", LazyProseFieldGroup],
["ProseH1DVue", LazyProseH1DVue],
["ProseH1", LazyProseH1],
["ProseH2DVue", LazyProseH2DVue],
["ProseH2", LazyProseH2],
["ProseH3DVue", LazyProseH3DVue],
["ProseH3", LazyProseH3],
["ProseH4DVue", LazyProseH4DVue],
["ProseH4", LazyProseH4],
["ProseHrDVue", LazyProseHrDVue],
["ProseHr", LazyProseHr],
["ProseIconDVue", LazyProseIconDVue],
["ProseIcon", LazyProseIcon],
["ProseImgDVue", LazyProseImgDVue],
["ProseImg", LazyProseImg],
["ProseKbdDVue", LazyProseKbdDVue],
["ProseKbd", LazyProseKbd],
["ProseLiDVue", LazyProseLiDVue],
["ProseLi", LazyProseLi],
["ProseOlDVue", LazyProseOlDVue],
["ProseOl", LazyProseOl],
["ProsePDVue", LazyProsePDVue],
["ProseP", LazyProseP],
["ProsePreDVue", LazyProsePreDVue],
["ProsePre", LazyProsePre],
["ProseScriptDVue", LazyProseScriptDVue],
["ProseScript", LazyProseScript],
["ProseStepsDVue", LazyProseStepsDVue],
["ProseSteps", LazyProseSteps],
["ProseStrongDVue", LazyProseStrongDVue],
["ProseStrong", LazyProseStrong],
["ProseTableDVue", LazyProseTableDVue],
["ProseTable", LazyProseTable],
["ProseTabsDVue", LazyProseTabsDVue],
["ProseTabs", LazyProseTabs],
["ProseTabsItemDVue", LazyProseTabsItemDVue],
["ProseTabsItem", LazyProseTabsItem],
["ProseTbodyDVue", LazyProseTbodyDVue],
["ProseTbody", LazyProseTbody],
["ProseTdDVue", LazyProseTdDVue],
["ProseTd", LazyProseTd],
["ProseThDVue", LazyProseThDVue],
["ProseTh", LazyProseTh],
["ProseTheadDVue", LazyProseTheadDVue],
["ProseThead", LazyProseThead],
["ProseTrDVue", LazyProseTrDVue],
["ProseTr", LazyProseTr],
["ProseUlDVue", LazyProseUlDVue],
["ProseUl", LazyProseUl],
["ProseCautionDVue", LazyProseCautionDVue],
["ProseCaution", LazyProseCaution],
["ProseNoteDVue", LazyProseNoteDVue],
["ProseNote", LazyProseNote],
["ProseTipDVue", LazyProseTipDVue],
["ProseTip", LazyProseTip],
["ProseWarningDVue", LazyProseWarningDVue],
["ProseWarning", LazyProseWarning],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
